import { useTranslation } from 'react-i18next'
import { useGetYearOverviewMetricsQuery } from 'store/queries/bolt-api/metrics'
import SectionPersonal from './sections/SectionPersonal.tsx'
import SectionCommunity from './sections/SectionCommunity.tsx'
import styles from './EnergyOverview.module.scss'
import LoadingCard from 'components/loading-card/LoadingCard.tsx'
import { useStoreSelector } from 'hooks/store.ts'
import PageLayout from 'layouts/page-layout/PageLayout.tsx'
import { FaqSlugB2C } from 'types/faq.ts'
import { Card } from '@boltenergy-be/design-system'
import { selectCurrentBillingContract } from 'store/contact/slice.ts'

const EnergyOverview = () => {
  // REDUX STORE
  const { contact } = useStoreSelector((store) => store.contact)
  const billingContract = useStoreSelector(selectCurrentBillingContract)

  // Redux Query
  const {
    data: yearOverviewData,
    isLoading,
    isFetching,
    isError
  } = useGetYearOverviewMetricsQuery(
    {
      email: contact?.email || '',
      billingContractNumber: billingContract.contractNumber
    },
    {
      skip: !contact
    }
  )

  // i18n
  const { t } = useTranslation(['energyOverview', 'common', 'errors'])

  return (
    <PageLayout
      title={t(($) => $.nav.energyOverview, {
        ns: 'common'
      })}
      faqCategories={{ b2c: [FaqSlugB2C.ENERGY_OVERVIEW] }}
    >
      <div className={styles.container}>
        {isLoading || isFetching ? (
          <>
            <LoadingCard key="personal-card" />

            <LoadingCard key="community-card" />
          </>
        ) : yearOverviewData ? (
          <>
            <Card as="section" className={styles['slider-card']}>
              <SectionPersonal
                data={yearOverviewData.yearOverviewMetrics.personal}
                communityReferrals={yearOverviewData.yearOverviewMetrics.community.referrals.total || 0}
              />
            </Card>

            <Card as="section" className={styles['slider-card']}>
              <SectionCommunity data={yearOverviewData.yearOverviewMetrics.community} />
            </Card>
          </>
        ) : (
          <Card className={styles['slider-card']}>
            <Card.Title>{t(($) => $.personal.title)}</Card.Title>
            <div className={styles.placeholder}>
              <p>
                {isError
                  ? t(($) => $.tryAgain, {
                      ns: 'errors'
                    })
                  : t(($) => $.personal.noData)}
              </p>
            </div>
          </Card>
        )}
      </div>
    </PageLayout>
  )
}

export default EnergyOverview
